<template>
  <div class="modal-wrapper">
    <ion-header translucent>
      <h4 style="position: absolute; top: 25px; left: 10%; width: 80%; margin: 0; text-transform: uppercase">{{
          title
        }}</h4>
      <svg class="icon icon-chevron-left" @click="dismissModal()">
        <use xlink:href="#icon-chevron-left"></use>
      </svg>
    </ion-header>
    <div class="modal-content-wrapper scroll-y custom-scrollbar">
      <img v-if="thumbnail" :src="thumbnail" style="width: 100%; height: auto; margin-top: 20px">
      <!--TODO TEST THIS @ ANDROID WEB VIEW-->
      <div v-if="video" class="video-wrapper">
        <video controls="controls" preload="auto" autoplay>
          <source :src="video" type="video/mp4">
        </video>
      </div>
      <p v-if="content">{{ content }}</p>
      <div v-if="html" v-html="html"></div>
      <ion-button v-if="route" mode="ios" expand="block" class="mt-10 mb-10" @click="goTo(route)">
        <span style="display: inline-block; vertical-align: middle"><strong>{{ ctaLabel }}</strong></span>
      </ion-button>
    </div>
  </div>
</template>

<script>
import router from '../router/index';

export default {
  router,
  name: 'Modal',
  props: ['thumbnail', 'title', 'content', 'html', 'video', 'ctaLabel', 'route', 'routeExternal'],
  methods: {
    dismissModal() {
      this.$ionic.modalController.dismiss()
    },
    goTo(route) {
      this.dismissModal()
      // external url
      if (this.routeExternal) {
        window.location.replace(route) // TODO test on mobile
      }
      // internal url
      else {
        // router is not available in the modal instance
        // wait for it to close
        setTimeout(() => {
          router.push(route)
        }, 250)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.video-wrapper{
  position: relative;
  width: 100%;
  height: 0;
  padding-bottom: 52%;
  video,
  iframe{
    position: absolute;
    top: 0;
    left: 0;
    width: 100% !important;
    height: 100% !important;
  }
}
</style>